/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.UserProgressVisibilityChirpService
 */

export const setUserProgressVisibilityRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.UserProgressVisibilityChirpService',
  rpcName: 'setUserProgressVisibility',
  auth: 'app',
  fingerprint: 'selmxmCDfX8cS2huumefVQDcfEtrWF5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};